/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Settings/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSettings from 'DesignSystem/Svgs/TysiaIconSettings/index'



/** @type {import('Simple/types.js').View} */
export default function Settings({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Settings",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconSettings
  viewPath={`${viewPath}/TysiaIconSettings`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsWhite : hovered ? dtColorsWhite : selected ? dtColorsWhite : dtColorsWhite}
/>
{children}
</React.Fragment>)
}